import type { IAttributes, IDirective, INgModelController } from "angular";
import { module } from "angular";

import { isNil } from "lodash";
import { tz } from "moment-timezone";
import "@progress/kendo-ui/js/kendo.datepicker";

import { InputDirectiveFunctions } from "App/Modules/Gui/Directives";

export default class InputDateDirective implements IDirective {
    public priority = 1000;

    public restrict = "E";

    public scope = {
        dateFormat: "<", // string
        dateFuture: "<", // boolean
        dateMax: "<", // Moment
        dateMin: "<", // Moment
        ignoreTime: "<", // boolean
        inclusive: "<", // boolean
        irLabel: "<",
        timeZone: "<", // it's not directive
    };

    public require = ["ngModel", "^form"];

    public template: string;

    public compile = InputDirectiveFunctions.compile(this.link); // eslint-disable-line @typescript-eslint/unbound-method

    constructor() {
        this.template = `
            <input
                autocomplete="off"
                type="text"
                date-format="{{dateFormat}}"
                ir-date-max="{{dateMax}}"
                ir-date-min="{{dateMin}}"
                ir-date-future="{{dateFuture}}"
                ir-valid-moment
                aa-field-group="ngModel"
                aa-label="{{irLabel | translate}}"
                k-format = "'{{dateFormat.replace('YYYY','yyyy').replace('DD','dd').replace('D','d')}}'"
                k-parse-formats="['{{dateFormat.replace('YYYY','yyyy').replace('DD','dd').replace('D','d')}}']"
                kendo-date-picker />
        `;
    }

    public link(scope: any, instanceElement: JQuery, instanceAttributes: IAttributes, ctrls: any[]) {
        InputDirectiveFunctions.link(scope, instanceElement, instanceAttributes);

        const ngModelCtrl = ctrls[0] as INgModelController;

        ngModelCtrl.$formatters.push((modelValue) => {
            if (scope.timeZone && modelValue) {
                return modelValue.clone().tz(scope.timeZone);
            }

            return modelValue;
        });

        // eslint-disable-next-line @typescript-eslint/unbound-method
        ngModelCtrl.$render = () => {
            if (ngModelCtrl.$viewValue) {
                scope.ngModel = ngModelCtrl.$viewValue.format(scope.dateFormat);
            }
        };

        scope.$watch("ngModel", (newValue: any, oldValue: any) => {
            if (newValue && newValue !== oldValue) {
                const timeZone = scope.timeZone || tz.guess();
                ngModelCtrl.$setViewValue(tz(newValue, scope.dateFormat, timeZone));
            } else if (!isNil(newValue) && newValue !== oldValue) {
                ngModelCtrl.$setViewValue(newValue);
            }
        });
    }
}

module("mmGui").directive("irInputDate", () => new InputDateDirective());
